import each from 'lodash/each'

export default {
  
  methods: {
    getAttributeFilters() {
        const attrs = {}
        each(this.$router.currentRoute.query, function(val, k){
            if(k.startsWith('eml__')){
                attrs[k] = val
            }
        })
        return attrs
    }
  }
}
